<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Zamówienia</h4>
          </md-card-header>
          <md-card-content>
            <md-table v-model="list">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="ID">{{ item.id }}</md-table-cell>
                <md-table-cell md-label="Email zam.">{{ item.user.cognitoId }}</md-table-cell>
                <md-table-cell md-label="Kwota">{{ item.totalPrice }} {{ item.currency.toUpperCase() }}</md-table-cell>
                <md-table-cell md-label="Status">{{ item.status }}</md-table-cell>
                <md-table-cell md-label="Data">{{ new Date(item.createdAt).toLocaleDateString() }}</md-table-cell>
                <md-table-cell md-label="Akcje">
                  <router-link :to="`/orders/${item.id}`">
                    <md-button class="md-primary">Zobacz</md-button>
                  </router-link>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <!-- <div class="md-layout-item md-size-100">
        
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "OrdersList",
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getOrders();
  },
  methods: {
    async getOrders() {
      return await this.$axios
        .get(`/orders/admin`)
        .then((res) => {
          this.list = res.data;
        })
        .catch((error) => {
          this.list = [];
        });
    },
  },
};
</script>
